// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_Header__PXAYg {
  padding: 24px 20px;
  border-bottom: 0.5px solid #F0F0F0;
  height: 8vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/app/components/Header/Header.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kCAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;AAAF","sourcesContent":[".Header {\n  padding: 24px 20px;\n  border-bottom: 0.5px solid #F0F0F0;\n  height: 8vh;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Header": `Header_Header__PXAYg`
};
export default ___CSS_LOADER_EXPORT___;
